import { Platform, View } from 'react-native'
import Icon from '@ui/elements/Icon'
import Typography from '@ui/typography'
import {
  colorBack,
  colorFront,
  colorBorder,
  iconBy,
  borderRadius,
} from './styles'
import { ToastProps as Props } from './types'
import { useTranslation } from 'react-i18next'
import cn from '@ui/utils/cn'
import Glass from '@ui/elements/Glass'
import { hex } from '@ui/utils/hex'
import Border from '@ui/effects/Border'
import Gradient from '@ui/effects/Gradient'
import { colors } from '@ui/colors'

export default function Toast({ title, text, icon, variant = 'info' }: Props) {
  const { t } = useTranslation(['toasts'])

  return (
    <Glass
      tint="prominent"
      className="relative inset-0 w-full"
      blur={Platform.select({ default: 100, web: 100 })}
      border={{
        borderWidth: 0,
        borderRadius,
      }}
      gradient={[colors.white, colors.white0]}
      gradientProps={{
        start: [0, 0.5],
        end: [1, 0.5],
      }}
    >
      <Border
        style={{
          borderRadius,
          borderColor: colorBorder[variant],
          borderWidth: 2,
        }}
      />
      <Gradient
        style={{
          borderRadius,
        }}
        colors={colorBack[variant]}
        start={[0, 0.5]}
        end={[1, 0.5]}
      />
      <View
        className={cn(
          'flex flex-row items-start justify-start gap-4 p-8',
          Platform.select({ default: 'gap-4', web: 'gap-8' })
        )}
      >
        <View className="flex h-8 w-8 flex-shrink-0 items-center justify-start">
          <Icon name={icon || iconBy[variant]} color={colorFront[variant]} />
        </View>
        <View className="flex-1 flex-col items-start gap-2">
          <Typography
            variant={Platform.select({ default: 'MDB', web: 'MDB' })}
            color={colorFront[variant]}
          >
            {title || t(`toasts:default.${variant}`)}
          </Typography>
          {!!text && (
            <Typography
              variant={Platform.select({ default: 'MD', web: 'MD' })}
              color={colorFront[variant]}
              className="opacity-60"
            >
              {text}
            </Typography>
          )}
        </View>
      </View>
    </Glass>
  )
}
